import { render, staticRenderFns } from "./aShopDetailRefundOrder.vue?vue&type=template&id=4bf10509&scoped=true"
import script from "./aShopDetailRefundOrder.vue?vue&type=script&lang=js"
export * from "./aShopDetailRefundOrder.vue?vue&type=script&lang=js"
import style0 from "./aShopDetailRefundOrder.vue?vue&type=style&index=0&id=4bf10509&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf10509",
  null
  
)

export default component.exports